import React from 'react';

import { useDispatch } from 'react-redux';

import { useHistory } from 'react-router-dom';
import Button from '../../button';
import Text from '../../text';
import { closeModal, openModal } from '../../../store/modules/modal-module';
import { Color } from '../../../styles/colors';
import ExitReverieModal from './exit-reverie-modal';

type Props = {
  to: string;
};

function ExitReverie({ to }: Props) {
  const history = useHistory();
  const dispatch = useDispatch();
  return (
    <div
      className="px-sm-20 px-md-120"
      style={{
        textAlign: 'center',
      }}
    >
      <ExitReverieModal
        onLeave={() => {
          history.push(to);
          dispatch(closeModal());
        }}
        onStay={() => dispatch(closeModal())}
      />
      <Text type="body2-blinkui" className="mb-sm-8" el="div" color={Color.black}>
        You are in BlinkRx.
      </Text>
      <Text type="body2-blinkui" el="div" color={Color.black}>
        <Button
          isReverie
          type="link"
          eventName="Opened Exit Reverie Modal"
          onClick={() => dispatch(openModal('leave-reverie'))}
        >
          Go to Blink Health
        </Button>{' '}
        to see past purchases and search out-of-pocket prices for over 15,000 medications.
      </Text>
    </div>
  );
}

export default ExitReverie;
